import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import {useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiInfo,FiCheck,FiXCircle,FiArrowRight,FiX,FiShield}=FiIcons;

export default function TreatmentCard({treatment}) {
  const [showModal,setShowModal]=useState(false);
  const navigate=useNavigate();
  const isAvailable=!treatment.availability.toLowerCase().includes('not available');

  return (
    <>
      <div className="premium-card-hover group relative flex h-full flex-col overflow-hidden rounded-[2rem] border border-slate-200/60 bg-white p-8">
        <div className="absolute right-0 top-0 -z-10 h-40 w-40 rounded-bl-full bg-teal-50/50 transition-transform duration-700 group-hover:scale-125" />
        <div className="mb-6 flex items-start justify-between">
          <div className="inline-flex items-center gap-1.5 rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white">
            <SafeIcon icon={FiShield} className="h-3 w-3 text-teal-400" />
            Rx Only
          </div>
        </div>
        <h3 className="mb-6 text-2xl font-extrabold leading-tight text-slate-900">{treatment.name}</h3>
        <div className="mb-6 flex min-h-[220px] flex-grow items-center justify-center border-y border-slate-100 py-8">
          {treatment.image ? (
            <img src={treatment.image} alt={treatment.name} className="h-48 w-48 object-contain drop-shadow-2xl transition-transform duration-700 group-hover:scale-110" />
          ) : (
            <div className="flex h-48 w-full items-center justify-center rounded-2xl border border-dashed border-slate-100 bg-slate-50 text-slate-400">
              <span className="text-sm font-medium">Image coming soon</span>
            </div>
          )}
        </div>
        <div className="mb-8 flex min-h-[40px] items-start gap-3 text-sm">
          <div className={`mt-0.5 shrink-0 rounded-full p-1 ${isAvailable ? 'bg-emerald-50 text-emerald-600' : 'bg-red-50 text-red-600'}`}>
            <SafeIcon icon={isAvailable ? FiCheck : FiXCircle} className="h-4 w-4" />
          </div>
          <span className="font-medium leading-relaxed text-slate-600">{treatment.availability}</span>
        </div>
        <div className="mt-auto flex flex-col gap-3">
          <button onClick={()=> navigate('/weightquiz')} className="flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-4 font-bold text-white shadow-lg transition-all duration-300 hover:bg-teal-700 hover:shadow-teal-900/20">
            Explore Care
            <SafeIcon icon={FiArrowRight} />
          </button>
          <button onClick={()=> setShowModal(true)} className="group/btn flex w-full items-center justify-center gap-2 rounded-xl border border-slate-200 bg-transparent px-4 py-4 font-bold text-slate-700 transition-all duration-300 hover:bg-slate-50">
            Clinical Details
            <SafeIcon icon={FiInfo} className="text-slate-400 transition-colors group-hover/btn:text-slate-700" />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {showModal && (
          <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            onClick={()=> setShowModal(false)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 p-4 backdrop-blur-md sm:p-6"
          >
            <motion.div
              initial={{scale: 0.95,opacity: 0,y: 20}}
              animate={{scale: 1,opacity: 1,y: 0}}
              exit={{scale: 0.95,opacity: 0,y: 20}}
              onClick={(event)=> event.stopPropagation()}
              className="relative max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-[2rem] bg-white p-8 shadow-2xl sm:p-10"
            >
              <button onClick={()=> setShowModal(false)} className="absolute right-6 top-6 rounded-full bg-slate-100 p-2 text-slate-600 transition-colors hover:bg-slate-200">
                <SafeIcon icon={FiX} className="h-5 w-5" />
              </button>
              <div className="mb-8 text-center">
                {treatment.image && (
                  <img src={treatment.image} alt={treatment.name} className="mx-auto mb-6 h-40 w-40 object-contain drop-shadow-xl" />
                )}
                <h3 className="mb-2 text-3xl font-extrabold text-slate-900">{treatment.name}</h3>
                <div className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-teal-50 px-3 py-1 text-xs font-bold uppercase tracking-widest text-teal-700">
                  <SafeIcon icon={FiShield} className="h-3 w-3" />
                  Prescription Required
                </div>
              </div>
              <div className="space-y-6">
                <div>
                  <h4 className="mb-3 text-xs font-bold uppercase tracking-widest text-slate-400">Clinical Description</h4>
                  <p className="text-[15px] leading-relaxed text-slate-600">{treatment.description}</p>
                </div>
                <div>
                  <h4 className="mb-3 text-xs font-bold uppercase tracking-widest text-slate-400">Availability Status</h4>
                  <div className="flex items-center gap-3 rounded-xl border border-slate-100 bg-slate-50 p-4 text-[15px] font-medium text-slate-700">
                    <SafeIcon icon={isAvailable ? FiCheck : FiXCircle} className={isAvailable ? 'h-5 w-5 text-emerald-500' : 'h-5 w-5 text-red-500'} />
                    {treatment.availability}
                  </div>
                </div>
                <div className="pt-4">
                  <button onClick={()=> navigate('/weightquiz')} className="flex w-full items-center justify-center gap-2 rounded-xl bg-teal-700 px-4 py-4 font-bold text-white shadow-lg transition-all duration-300 hover:bg-teal-600 hover:shadow-teal-700/30">
                    Explore Your Care Options
                    <SafeIcon icon={FiArrowRight} />
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}